import getters from './getters'
import EducationsFactory from '@/factory/educations'

export default {
  state: {
    educations: new EducationsFactory().create(),
  },
  getters: getters,
}
